<template>
	<section id="app">
        <router-view v-if="isRouterAlive" />
	</section>
</template>

<script>
export default {
    data() {
        return {
            isRouterAlive: true
        }
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        }
    }
}
</script>

<style lang="less">
@import './assets/css/app.less';
</style>